export default 'M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm1.5 18a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3z';